<div class="col-md-2 col-sm-4">
  <ul class="nav nav-pills nav-stacked">
    <li 
      class="clickable"
      role="presentation"
      (click)="goToDetails()">
      <a>Experiment Details</a>
    </li>
    <li 
      class="active clickable"
      [ngClass]="{ 'clickable': experimentDesignFormGroup.valid }"
      role="presentation">
      <a>Experiment Design</a>
    </li>
  </ul>
</div>
<div class="col-md-10 col-sm-8">
  <app-experiment-design-form 
    [options]="options"
    [experimentDesignFormGroup]="experimentDesignFormGroup"
    [requestDetails]="requestDetails">
  </app-experiment-design-form>
    
  <div class="pull-right">
    <button type="button" class="btn btn-default" (click)="goToDetails()">Back to Details</button>
    <button type="button" class="btn btn-default" (click)="save()" [disabled]="saving">Save</button>
    <button type="button" class="btn btn-success" (click)="saveAndSubmit()" [disabled]="experimentDesignFormGroup.invalid || submitting">Save and Submit</button>
  </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/experiment-design-form-page/experiment-design-form-page.component.html